import Flickity from 'flickity'

export default class IAFlickity {
    constructor(element, options) {
        this.instance = new Flickity(element, options)
    }
}